export default __webpack_public_path__ + "static/media/healthDetails.adc3c041.svg";